module.exports = __webpack_public_path__ + "img/ic_feedback.a611f283.svg";